import { motion } from 'framer-motion';
import { VslPlayer } from '../VslPlayer';

// SECCIÓN 01 — HERO + VSL (visible siempre, sin delay, SIN CTA).
// Fondo negro con ondas magenta (fondo-001.webp = waveform original limpio).
export function S01Hero() {
  return (
    <section className="relative overflow-hidden bg-rc-black">
      <img
        src="/img/fondo-001.webp"
        alt=""
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 h-full w-full object-cover opacity-90"
      />
      <div className="relative mx-auto w-full max-w-4xl px-4 pt-10 pb-16 md:pt-16 md:pb-24">
        <motion.h1
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="text-center font-display text-2xl leading-snug font-bold tracking-wide text-white uppercase md:text-4xl"
        >
          DESCUBRE AHORA COMO{' '}
          <span className="text-rc-magenta-bright">ACABAR CON LA PROCASTINACIÓN</span> Y SALIR DEL
          CICLO DE ESTANCAMIENTO PARA MEJORAR TUS RESULTADOS PROFESIONALES CON 30 PILDORAS
          AUDITIVAS.
        </motion.h1>

        <motion.div
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: 'easeOut', delay: 0.2 }}
          className="mx-auto mt-8 w-full max-w-3xl md:mt-12"
        >
          <VslPlayer />
        </motion.div>
      </div>
    </section>
  );
}
